export class SearchEvent extends CustomEvent {
  constructor(searchTerm) {
    super('search', { detail: searchTerm })
  }
}
